import React, { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import Loader from "designs/v1/pages/ModifyKyc/components/Loader";
import {
  getUserValue,
  removeUserValue,
  getRequestTypeStagesApi,
} from "../services";

const ModificationType = ({ stageScreen, setStageScreen }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const initialValues = {
    request_type: "",
  };
  const validationSchema = Yup.object().shape({
    // request_type: Yup.string().required(),
    request_type: Yup.array().min(1),
  });
  const [requestOption, setRequestOption] = useState([]);

  useEffect(() => {
    setLoading(true);
    const loadRequestTypes = async () => {
      try {
        const resp = await getRequestTypeStagesApi();
        let data = resp.data?.data || [];
        data = data.filter(
          (item) => item.allow_to_client_for_modification === 1
        );
        setRequestOption(
          data.filter((item) => item.name !== "Mobile and Email Modification")
        );
        setLoading(false);
      } catch (error) {
        console.error("err", error);
        setLoading(false);
      }
    };
    loadRequestTypes();
  }, []);

  useEffect(() => {
    removeUserValue();
  }, []);

  const handleSubmit = async (value) => {
    // const payload = {
    //   ...getUserValue(),
    //   ...value,
    // };
    // console.log("payload", value.request_type);
    const user = JSON.parse(sessionStorage.getItem("user") || {});
    delete user["pan"];
    sessionStorage.setItem("user", JSON.stringify({ ...user }));
    localStorage.removeItem("RequestTypeStage");
    localStorage.removeItem("RequestTypes");
    localStorage.removeItem("RequestTypeDocs");
    if (value.request_type.length > 1) {
      const checkArr = ["Mobile Modification", "Email Modification"];
      const exists = checkArr.every((item) =>
        value.request_type.includes(item)
      );
      const filteredArr = value.request_type.filter(
        (item) => !checkArr.includes(item)
      );
      if (exists) {
        setStageScreen("Mobile and Email Modification");
        // localStorage.setItem("RequestTypeStage", JSON.stringify(filteredArr));
        // localStorage.setItem("RequestTypes", JSON.stringify(filteredArr));
        const requestType = ["MobileEmailModifications", ...filteredArr];
        localStorage.setItem("RequestTypeStage", JSON.stringify(requestType));
        localStorage.setItem("RequestTypes", JSON.stringify(requestType));
      } else {
        setStageScreen(value.request_type[0]);
        localStorage.setItem(
          "RequestTypeStage",
          JSON.stringify(value.request_type)
        );
        localStorage.setItem(
          "RequestTypes",
          JSON.stringify(value.request_type)
        );
      }
    } else {
      setStageScreen(value.request_type[0]);
    }
    // if (value.request_type.length === 1) {
    //   setStageScreen(value.request_type[0]);
    // } else {
    //   setStageScreen(value.request_type);
    // }
    // setIsLoading(true);
    // try {
    //   const resp = await createKycRequest(payload);
    //   console.log("resp", resp);
    //   sessionStorage.setItem("user", JSON.stringify(payload));
    //   setIsLoading(false);
    //   loadScreen(payload);
    // } catch (error) {
    //   console.log("err", error);
    //   setIsLoading(false);
    // }
  };

  if (loading) {
    return <Loader />;
  }
  return (
    <>
      <Title title="Modify your KYC" />
      <div className="row">
        <div className="col-md-12">
          <div className="form-group">
            <div className="mb-2">
              <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ isValid, dirty, isSubmitting }) => (
                  <Form>
                    <div className="form-group my-2">
                      <Field
                        name="request_type"
                        className="form-control"
                      >
                        {({ field }) => {
                          return requestOption.map((option, index) => {
                            return (
                              <div key={option.name}>
                                {index === 0 && (
                                  <h6
                                    className="mt-1 py-1 border-bottom border-gray"
                                    style={{ width: "300px" }}
                                  >
                                    With KRA
                                  </h6>
                                )}
                                {index === 3 && (
                                  <h6
                                    className="mt-1 py-1 border-bottom border-gray"
                                    style={{ width: "300px" }}
                                  >
                                    Without KRA
                                  </h6>
                                )}
                                <div>
                                  <input
                                    type="checkbox"
                                    {...field}
                                    value={option.name}
                                  />
                                  <label className="mx-2">{option.name}</label>
                                </div>
                              </div>
                            );
                          });
                        }}
                      </Field>
                    </div>
                    <div className="d-flex mt-4">
                      <div className="mx-1">
                        <Button
                          type="button"
                          title="Back"
                          handleClick={() => setStageScreen("")}
                          disabled={isLoading}
                        />
                      </div>
                      <div className="mx-1">
                        <Button
                          title="Next"
                          disabled={
                            !isValid || !dirty || isSubmitting || isLoading
                          }
                        />
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ModificationType;
